import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import type { AgenciaResumo } from "@/hooks/useAgenciaTimeline";

// v_agencia_resumo (sql/150) ainda não está no types.ts gerado -> cast, mesmo
// padrão das demais consultas a views/RPCs novas neste plano.
const resumoDb = supabase as unknown as {
  from: (table: string) => any; // eslint-disable-line @typescript-eslint/no-explicit-any
};

/**
 * Golden record da agência (cards do topo da página de detalhe): vagas
 * abertas/aprovadas/reprovadas, projetos e freelancers ativos agora, médias
 * de avaliação bidirecionais. Consulta direta à view (não à RPC de
 * composição da timeline) porque os cards do header precisam existir antes
 * de qualquer aba abrir — e a view não depende de janela de tempo, é sempre
 * o estado "agora".
 */
export function useAgenciaResumo(agenciaId?: string | null) {
  return useQuery({
    queryKey: ["agencia-resumo", agenciaId],
    enabled: !!agenciaId,
    staleTime: 5 * 60 * 1000,
    queryFn: async (): Promise<AgenciaResumo | null> => {
      const { data, error } = await resumoDb
        .from("v_agencia_resumo")
        .select("*")
        .eq("agencia_id", agenciaId)
        .maybeSingle();
      if (error) throw error;
      return (data as AgenciaResumo) ?? null;
    },
  });
}
